import { atom } from 'jotai'

// Auth state atoms
export const employeeTokenAtom = atom<string | null>(null)
export const isAuthLoadingAtom = atom<boolean>(false)
export const authErrorAtom = atom<string | null>(null)
export const hasAttemptedLoginAtom = atom<boolean>(false)

// Derived: Check if authenticated
export const isAuthenticatedAtom = atom(get => {
    return get(employeeTokenAtom) !== null
})

// Action: Set token
export const setEmployeeTokenAtom = atom(null, (_get, set, token: string) => {
    set(employeeTokenAtom, token)
    set(authErrorAtom, null)
})

// Action: Clear auth
export const clearAuthAtom = atom(null, (_get, set) => {
    set(employeeTokenAtom, null)
    set(authErrorAtom, null)
})
